import React from "react";
import "../../css/welcome/welcome.css";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const Welcome = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="row text-center welcome-box">
        <div className="center-box m-auto pl-2 pr-2">
          <p className="lead mb-1 text-bold">{t('welcome.pageNotFound')}</p>
          <p className="text-small text-gray">
            {t('welcome.pageNotFoundMessage')}
          </p>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({ state: state });
export default connect(mapStateToProps)(Welcome);
